import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingPaymentsByDueDateAPI = async (params: {
  dueDate: string;
  format: string;
}) => {
  const response = await baseAPI.get<string>(
    '/reporting/payments-by-due-date',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingPaymentsByDueDate = (params: {
  dueDate: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [KEYS.PAYMENTS_BY_DUE_DATE, params.dueDate, params.format],
    queryFn: () => reportingPaymentsByDueDateAPI(params),
    enabled: !!params.dueDate && !!params.format,
  });
};
